import { useMemo } from "react"
import { DownloadFilesModal, fileHelpers, fileNameFromUrl, FileOption } from "../../../../../features/files"
import { PaymentOrder, PaymentOrderStatus } from "../../../state/types"
import { PaymentOrderPDF } from "../payment-order-pdf/paymentOrderPDF"
import { RetentionCertificatePDF } from "../retention-certificate-pdf/retentionCertificatePDF"

type Props = {
    paymentOrder?: PaymentOrder
}

export const DownloadPaymentOrderFilesModal = (props: Props) => {
    const { paymentOrder } = props

    const { paymentOrderFileName, retentionCertificateFileName } = fileHelpers

    const fileOptions = useMemo(() => {
        if (!paymentOrder) return []
        
        const options: FileOption[] = []

        options.push({
            id: 'order-pdf',
            label: 'Orden de Pago',
            fileName: paymentOrderFileName(paymentOrder.code),
            pdf: {
                id: 'order-pdf',
                component: <PaymentOrderPDF id="order-pdf" paymentOrder={paymentOrder} />
            }
        })

        if (paymentOrder?.receiptUrl) {
            options.push({
                id: 'receipt',
                label: 'Comprobante de Pago',
                fileName: fileNameFromUrl(paymentOrder.receiptUrl)!,
                url: paymentOrder.receiptUrl
            })
        }

        if (paymentOrder && paymentOrder?.status === PaymentOrderStatus.PAYED && paymentOrder.taxItems.length > 0) {
            options.push({
                id: 'retention-certificate',
                label: 'Certificado de Retención',
                fileName: retentionCertificateFileName(paymentOrder.code),
                pdf: {
                    id: 'retention-certificate',
                    component: <RetentionCertificatePDF id="retention-certificate" paymentOrder={paymentOrder} />
                }
            })
        }

        return options
    }, [paymentOrder])
    
    return <DownloadFilesModal fileOptions={fileOptions} />
}
